var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1200,
    zoomAndPan: "magnify",
    viewBox: "0 0 900 899.99999",
    height: 1200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a1340857cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 90 90 L 809.425781 90 L 809.425781 809.425781 L 90 809.425781 Z M 90 90 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3c3ead19ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 331 275.097656 L 681.527344 275.097656 L 681.527344 625.117188 L 331 625.117188 Z M 331 275.097656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7ebf754619"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 218.417969 429 L 414 429 L 414 625.117188 L 218.417969 625.117188 Z M 218.417969 429 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a1340857cc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#26a4ca",
    d: "M 449.710938 809.425781 C 353.675781 809.425781 263.242188 772.042969 195.382812 704.042969 C 127.378906 636.183594 90 545.75 90 449.710938 C 90 353.675781 127.378906 263.242188 195.382812 195.382812 C 263.242188 127.378906 353.675781 90 449.710938 90 C 545.75 90 636.183594 127.378906 704.042969 195.382812 C 772.042969 263.386719 809.425781 353.675781 809.425781 449.710938 C 809.425781 545.75 772.042969 636.183594 704.042969 704.042969 C 636.183594 772.042969 545.75 809.425781 449.710938 809.425781 Z M 449.710938 111.566406 C 359.425781 111.566406 274.457031 146.789062 210.621094 210.621094 C 146.789062 274.457031 111.566406 359.425781 111.566406 449.710938 C 111.566406 540 146.789062 624.96875 210.621094 688.800781 C 274.457031 752.636719 359.425781 787.859375 449.710938 787.859375 C 540 787.859375 624.96875 752.636719 688.800781 688.800781 C 752.636719 624.96875 787.859375 540 787.859375 449.710938 C 787.859375 359.425781 752.636719 274.457031 688.800781 210.621094 C 624.96875 146.789062 540 111.566406 449.710938 111.566406 Z M 449.710938 111.566406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3c3ead19ad)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#26a4ca",
    d: "M 681.535156 316.285156 L 372.789062 625.21875 L 331.628906 584.03125 L 640.371094 275.089844 L 681.535156 316.285156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7ebf754619)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#26a4ca",
    d: "M 372.789062 625.21875 L 218.417969 470.75 L 259.582031 429.5625 L 413.960938 584.03125 L 372.789062 625.21875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassIcon);
export default __webpack_public_path__ + "static/media/pass_icon.1e7f8d1d1f32d62be787b028e31d01ec.svg";
export { ForwardRef as ReactComponent };